import { ActivatedRoute, Router } from '@angular/router';
import {
  generateRouterQueryParams,
  getDataFromRouterQueryParams,
} from './routing';
import Bugsnag from '@bugsnag/js';
export const ERROR_QUERY_KEY = 'error';
/**
 * Returns a QueryParam object with filters
 */
function convertErrorDataToQuery(
  errorResponse: unknown
): Record<string, string> {
  return generateRouterQueryParams(ERROR_QUERY_KEY, errorResponse);
}

/**
 * Navigates to error page with errorData in queryParams.
 */
export async function navigateToErrorPage(
  errorResponse: unknown,
  router: Router
) {
  await router.navigate(['error'], {
    queryParams: convertErrorDataToQuery(errorResponse),
  });
}

/**
 * Get filter from query param if present in ActivatedRoute
 */
export function getErrorFromUrl(route: ActivatedRoute): unknown {
  return getDataFromRouterQueryParams(ERROR_QUERY_KEY, route);
}

/** Extract error message from API response */
export function getErrorMessageFromResponse(errorResponse: any): string {
  // handle errors with status code greater than 500
  if (errorResponse.status > 500) {
    // Notify Bugsnag about the error
    const headers: Record<string, string> = {};
    errorResponse.headers?.keys().forEach((key: string) => {
      headers[key] = errorResponse.headers.get(key) ?? '';
    });

    Bugsnag.notify(errorResponse, (event) => {
      if (errorResponse.headers) {
        event.addMetadata('headers', headers);
      }
    });
    return 'There was an error processing your request. Please try again later.';
  }

  if (errorResponse.error && errorResponse.error.message) {
    return errorResponse.error.message;
  } else if (errorResponse.message) {
    return errorResponse.message;
  } else {
    console.error(errorResponse); // eslint-disable-line no-console
    return 'An unexpected error occurred.';
  }
}

/** Extract HTTP Status code from API response */
export function getErrorStatusFromResponse(errorResponse: any): string {
  if (typeof errorResponse.status === 'number') {
    return errorResponse.status;
  } else {
    return '';
  }
}
